import { render, staticRenderFns } from "./Propuesta.vue?vue&type=template&id=7046b972"
import script from "./Propuesta.vue?vue&type=script&lang=js"
export * from "./Propuesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports